import { render, staticRenderFns } from "./ComRequirementsComponent.vue?vue&type=template&id=4e49922a&"
import script from "./ComRequirementsComponent.vue?vue&type=script&lang=js&"
export * from "./ComRequirementsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports